// extracted by mini-css-extract-plugin
module.exports = {"dot":"hh2iC","blink":"_2yJ34"};